import { render } from "./FileUploads.vue?vue&type=template&id=3ef30764"
import script from "./FileUploads.vue?vue&type=script&lang=js"
export * from "./FileUploads.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__